module.exports = __webpack_public_path__ + "static/media/email-settings-02.19085f04.png";